import React, { useEffect } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import Checkbox from "@mui/material/Checkbox";
import { Button, CardActionArea, CardActions } from "@mui/material";
import { useProductsContext } from "../../Contexts/SidebarContext";
import { CommonUtil } from "../../utils/CommonUtil";
import { NetworkManager } from "../../Components/NetworkManager";
import ToastManager from "../ToastManager";

const ConnectOrganicInstaPost = ({ templateName, handleClose }: any) => {
  const { pageInfo } = useProductsContext();
  const [media, setMedia] = React.useState([]);
  const [postPublish, setPostPublish] = React.useState<any>([]);

  useEffect(() => {
    let params: any = "";
    let pageId = pageInfo?.pageId;
    let instaId = pageInfo?.instaId;
    if (pageId) {
      params = `pageId=${pageId}&instaId=${instaId}`;
      try {
        NetworkManager.sendJsonRequest(
          "api/instagram/getMediaIds",
          "",
          params,
          "GET",
          true,
          onSuccessCallInsta,
          onErrorCall
        );
      } catch (error) {}
    }
  }, []);

  const onClickSelectPost = (e: any, post: any) => {
    const ischecked = e.target.checked;
    const newSelect = post.postId;
    if (ischecked) {
      setPostPublish((prevPost: any) => [...prevPost, newSelect]);
    } else {
      if (postPublish && postPublish.length > 0) {
        const tempArray = postPublish.filter(
          (item: any) => item !== post.postId
        );
        setPostPublish(tempArray);
      }
    }
  };
  const onSuccessCallInsta = (data: any) => {
    var respData = CommonUtil.parseData(data);
    if (respData) {
      setMedia(respData?.mediaList);
    }
  };
  const onSuccessCall2 = (data: any) => {
    var respData = CommonUtil.parseData(data);
    if (respData) {
      ToastManager.showToast(
        "The selected posts are associated to the template.",
        "Success"
      );
      handleClose();
    }
  };

  const onErrorCall = (err: any) => {
    ToastManager.showToast(
      "Error Occured while associating the posts to the template.",
      "Error"
    );
  };
  const onPostSpecificPublish = () => {
    let tempArray: any = [];
    const getPostid = () => {
      postPublish?.length > 0 &&
        postPublish.forEach((pB: any) => {
          tempArray.push({
            postId: pB,
          });
        });
      return tempArray;
    };
    const req = {
      templateName: templateName,
      pageId: pageInfo.pageId,
      postIds: getPostid(),
    };

    try {
      NetworkManager.sendJsonRequest(
        "tieMultiplePostIds",
        req,
        "",
        "POST",
        true,
        onSuccessCall2,
        onErrorCall
      );
    } catch (error) {}
  };
    return (
      <>
        <div>
          {media?.length > 0 &&
            media.map((medi: any, indx: any) => {
              const idPost = medi?.mediaId;
              return (
                <div key={idPost} style={{ margin: "10px" }}>
                  <Card sx={{ maxWidth: 345, margin: "auto" }}>
                    <CardActionArea>
                      {medi?.mediaURL !== "" ? (
                        <CardMedia
                          component="img"
                          height="140"
                          image={medi?.mediaURL}
                          alt="post media"
                        />
                      ) : null}
                      <CardContent>
                        <Typography gutterBottom variant="h5" component="div">
                          {medi?.caption}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          {medi?.caption}
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                    <CardActions>
                      <Typography>Select Post</Typography>
                      <Checkbox
                        aria-label="Hey"
                        name="checked"
                        onChange={(e) => onClickSelectPost(e, medi)}
                      />
                    </CardActions>
                  </Card>
                </div>
              );
            })}
        </div>
        <hr />
        <div className="modal-footer pt-0">
          <Button type="button" onClick={onPostSpecificPublish}>
            Publish
          </Button>
        </div>
      </>
    );
};

export default ConnectOrganicInstaPost;
